export class ProjectsModel {
  items: ProjectModel[] = [];
}

export class ProjectModel {
  title: string;
  icons: ProjectIconModel[] = [];
  uri: string; 
}

class ProjectIconModel {
  name: string;
  key: string;
  id: number;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/projects/projectsModel.tsx